import { Autocomplete, TextField } from "@mui/material";
import { EtiquetteInfos as LabelInfos } from "components/WarehouseElements/Grid/Etiquette/EtiquetteInfos";
import { useAppDispatch, useAppSelector } from "hooks/StoreHooks";
import { Serializable } from "models/Serializable";
import { JSX, SyntheticEvent, useState, useEffect } from "react";
import { getShortcuts as getShortcuts } from "store/Selectors/gridLayoutSelector";
import { centerIntoView } from "utils/centerIntoView";
import { useSearchParams } from "react-router";
import { getIsGridRendered } from "store/Selectors/warehousePlanSelector";
import { PARAM_KEY } from "constants/navigation";
import { addNewURLQueryParams } from "utils/getNewURLQueryParams";
import { setURLParamDefaultPosition } from "store/Slices/gridEventSlice";

export class Shortcut implements Serializable<Shortcut> {
  type = "";
  id = "";
  label!: LabelInfos;

  deserialize(input: any): Shortcut {
    this.type = input.type;
    this.id = input.id;
    this.label = new LabelInfos().deserialize(input.etiquette);
    return this;
  }
}

export function Shortcuts(): JSX.Element {
  const shortcuts: Shortcut[] = useAppSelector(getShortcuts);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedShortcutName, setSelectedShortcutName] = useState("");
  const isGridRendered = useAppSelector(getIsGridRendered);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const defaultPosition = searchParams.get(PARAM_KEY.SHORTCUT);
    if (defaultPosition && isGridRendered) {
      /* eslint-disable */
      const gridPositionRegex = new RegExp("(^[0-9]+,[0-9]+$)");
      const regexMatch = gridPositionRegex.test(defaultPosition);
      if (regexMatch) {
        dispatch(setURLParamDefaultPosition(defaultPosition));
      } else {
        const shortcut = shortcuts.find(
          x => x.label.description == defaultPosition
        );
        if (shortcut) centerIntoView(shortcut.id);
      }
    }
    return;
  }, [searchParams, isGridRendered]);

  const onChange = (
    _event: SyntheticEvent<Element, Event>,
    value: string | null
  ) => {
    if (value != "") {
      const selectedShortcut = shortcuts.find(
        shortcut => shortcut.label.description === value
      );
      if (selectedShortcut) {
        const newURLParams = addNewURLQueryParams(
          selectedShortcut.label.description,
          PARAM_KEY.SHORTCUT,
          searchParams
        );
        setSearchParams(newURLParams);
        centerIntoView(selectedShortcut.id);
      }
      setSelectedShortcutName("");
    }
  };

  return (
    <Autocomplete
      id="shortcuts"
      className="combo"
      options={shortcuts?.map(shortcut => shortcut.label.description)}
      onChange={onChange}
      value={selectedShortcutName}
      blurOnSelect
      size="small"
      style={{
        width: "250px",
      }}
      renderInput={params => <TextField {...params} label="Aller à" />}
    />
  );
}
